<template lang="pug">
  div
    .row(v-if="isPresent(registration.program.registration_information)")
      .columns.large-24
        article.content-block
          header
            .title {{t('app.registration.other_information')}}
          section.content.other-registration-information
            table.table-condensed
              tbody
                tr
                  td(v-html="to_br(registration.program.registration_information)", v-linkified="")

    .row(v-if="registration.preview && !registration.program.template_preview && isPresent(registration.program.product_payment_methods)")
      .columns.large-24
        article.content-block
          header
            .title {{t('app.registration.show.summary_offline_methods')}}
          section.content
            table.table-condensed
              tbody
                tr(v-for="product_payment_method in registration.program.product_payment_methods")
                  td(:class="{'future-section': future_section(product_payment_method)}")
                    .future-message(v-if="future_section(product_payment_method)")
                      | {{t('app.registration.payment.payment_is_restricted')}}
                    strong {{product_payment_method.payment_method_name}}
                    p.small(v-html="$sanitize(to_br(product_payment_method.payment_method_instructions))")


    .row(v-if="registration.preview && !registration.program.template_preview && isPresent(refund_instructions = registration.program.refund_instructions)")
      .columns.large-24
        article.content-block
          header
            .title {{t('app.registration.payment.refund_instructions')}}
          section.content
            table.table-condensed
              tr
                td(style="border: 0px;padding: 0.5rem;", v-html="$sanitize(to_br(refund_instructions))")

</template>
<script>
  import helpers from 'code/base_mixins'
  export default {
    name: "additional_data",
    mixins: [helpers],
    methods: {
      future_section (product_payment_method){
        if (!this.registration.preview) return null
        return product_payment_method.payment_method_has_filters
      }
    },
    computed: {
      registration(){
        return this.state.current_reg
      },
    }
  }
</script>
